import { render } from "./CreateRedPack.vue?vue&type=template&id=923b0828&scoped=true&ts=true"
import script from "./CreateRedPack.vue?vue&type=script&lang=ts"
export * from "./CreateRedPack.vue?vue&type=script&lang=ts"

import "./CreateRedPack.vue?vue&type=style&index=0&id=923b0828&lang=scss&scoped=true"

import exportComponent from "/Users/hari/Project/FunctionX/fx-redpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-923b0828"]])

export default __exports__